import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
// import { screenChange } from "../../store/screenSlice";

// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import { TextField } from "@mui/material";
import {
  // updateEvent,
  addLocationInfo,
} from "../../store/eventApiSlice";
// import { DevTool } from "@hookform/devtools";
// import CurrencyInput from "react-currency-input-field";
import {
  useForm,
  // Controller,
  // useFormContext,
  // Merge,
  // FieldError,
  // FieldErrorsImpl,
} from "react-hook-form";
import { Button, Label, PageLink } from "../StyledComp/StyledComp";
// import { DateValidationError } from "@mui/x-date-pickers";
// import dayjs, { Dayjs } from "dayjs";
// import { all } from "axios";
// import { invalid } from "moment";
import ReactModal from "react-modal";
// import MemberServices from "../../services/MemberServices";
import EventService from "../../services/EventServices";
import AdminUserService from "../../services/adminUserServices";

interface IConfiguration {
  [key: string]: any;
}

interface Location {
  Id: number | null;
  LocationId: number | null;
  Location: string | null;
  Cost: number | null;
}

interface LocationsFormValue {
  FormCost1: number | null;
  FormLocation1: string | null;
  FormCost2: number | null;
  FormLocation2: string | null;
  FormCost3: number | null;
  FormLocation3: string | null;
}

interface ChildProps {
  closeLocationModal: (flag: boolean) => void;
  closeAddLocationDialog?: () => void;
  addLocationDialogOpen?: boolean;
  setAddLocationDialogOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

interface AddFormValue {
  Location: string | null;
  Status: string | null;
}

const AddLocationInfo: React.FC<ChildProps> = (props) => {
  const dispatch = useDispatch();
  // dispatch(screenChange("Events"));

  // const { errors: errorsLocation } = formStateLocation;

  const eventInfo = useSelector(
    (state: RootState) => state.eventapislice.event
  );
  console.log("event:", eventInfo.Locations);
  const [LocationCount, setLocationCount] = useState<number>(
    eventInfo.Locations != null ? eventInfo.Locations!.length : 0
  );
  // setLocationCount();

  const {
    closeLocationModal,
    addLocationDialogOpen,
    closeAddLocationDialog = () => {},
  } = props;

  const [LocationId1, setLocationId1] = useState<number | null>(null);
  const [Location1, setLocation1] = useState<string>("");
  // const [Cost1, setCost1] = useState<number | null>(null);
  const [LocationId2, setLocationId2] = useState<number | null>(null);
  const [Location2, setLocation2] = useState<string>("");
  // const [Cost2, setCost2] = useState<number | null>(null);
  const [LocationId3, setLocationId3] = useState<number | null>(null);
  const [Location3, setLocation3] = useState<string>("");
  // const [Cost3, setCost3] = useState<number | null>(null);

  /* ----use config list as temporary place holder for Location name  */
  const [LocationDesc, setLocationDesc] = useState<IConfiguration>([]);

  const form = useForm<LocationsFormValue>();
  const Locationform = useForm<AddFormValue>();

  const { register, handleSubmit } = form;
  // const { register: locationRegister, control: locationControl, handleSubmit: locationHandleSubmit, formState: locationFormState, setValue: locationSetValue, reset } = Locationform;

  // const [addLocationDialog, setaddLocationDialog] = useState<boolean>(false);
  const [isLodactionAdded, setisLodactionAdded] = useState<boolean>(false);

  // const { errors } = formState;

  useEffect(() => {
    console.log(addLocationDialogOpen);
    const getConfigurationLists = async () => {
      console.log("getConfigurationLists called");

      const response = await EventService.getConfigurableLocation();
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        setLocationDesc(response.data.data);
      } else {
      }
    };

    getConfigurationLists();
    // setaddLocationDialog(addLocationDialog)
    // setAddLocationDialogOpen(addLocationDialog);
    console.log(addLocationDialogOpen);

    // console.log(addLocationDialog)
  }, [isLodactionAdded]);

  // Comments: Will be accessed from both onChange and submit
  let obj1: Location = {
    Id: LocationId1,
    LocationId: LocationId1,
    Location: Location1,
    Cost: null,
  };
  let obj2: Location = {
    Id: LocationId2,
    LocationId: LocationId2,
    Location: Location2,
    Cost: null,
  };
  let obj3: Location = {
    Id: LocationId3,
    LocationId: LocationId3,
    Location: Location3,
    Cost: null,
  };

  const onChangeHandler = (e: any, index: number) => {
    console.log("value", e.target.value);
    console.log("name", e.target.name);
    console.log("index", index);
    switch (e.target.name) {
      case "FormLocation1":
        obj1 = {
          Id: index,
          LocationId: null,
          Location: e.target.value,
          Cost: null,
        };
        setLocationId1(index);
        setLocation1(e.target.value);
        break;
      // case "FormCost1":
      //   obj1 = {
      //     Id: LocationId1,
      //     Location: Location1,
      //     Cost: e.target.value,
      //   };
      //   // setCost1(e.target.value);
      //   break;
      case "FormLocation2":
        obj2 = {
          Id: index,
          LocationId: null,
          Location: e.target.value,
          Cost: null,
        };
        setLocationId2(index);
        setLocation2(e.target.value);
        break;
      // case "FormCost2":
      //   obj2 = {
      //     Id: LocationId1,
      //     Location: Location2,
      //     Cost: e.target.value,
      //   };
      //   // setCost2(e.target.value);
      //   break;
      case "FormLocation3":
        obj3 = {
          Id: index,
          LocationId: null,
          Location: e.target.value,
          Cost: null,
        };
        setLocationId3(index);
        setLocation3(e.target.value);
        break;
      // case "FormCost3":
      //   obj3 = {
      //     Id: LocationId3,
      //     Location: Location3,
      //     Cost: e.target.value,
      //   };
      //   // setCost3(e.target.value);
      //   break;
      default:
        console.log("Default case called");
        break;
    }
    // console.log("object1:", obj1);
    // console.log("object1:", obj2);
    // console.log("object1:", obj3);

    /* push obj1 to store  */
  };
  const onSubmit = (e: any) => {
    console.log("SUBMIT");

    if (obj1.Id != null) {
      console.log("obj1-1:", obj1);
      dispatch(
        addLocationInfo({
          key: "Locations",
          value: obj1,
        })
      );
    }
    // else if (
    //   (obj1.Location == "" && obj1.Cost != null) ||
    //   (obj1.Location != "" && obj1.Cost == null)
    // ) {
    //   alert("Please enter both Location desc and Location");
    // }

    // obj2
    if (obj2.Id != null) {
      console.log("object2:", obj1);
      dispatch(
        addLocationInfo({
          key: "Locations",
          value: obj2,
        })
      );
    }
    // else if (
    //   (obj2.Location == "" && obj2.Cost != null) ||
    //   (obj2.Location != "" && obj2.Cost == null)
    // ) {
    //   alert("Please enter both Location desc and Location");
    // }

    // obj3
    if (obj3.Id != null) {
      console.log("object3:", obj3);
      dispatch(
        addLocationInfo({
          key: "Locations",
          value: obj3,
        })
      );
    }
    // else if (
    //   (obj3.Location == "" && obj3.Cost != null) ||
    //   (obj3.Location != "" && obj3.Cost == null)
    // ) {
    //   alert("Please enter both Location desc and Location");
    // }

    closeLocationModal(false);
  };

  const addLocation = async (data: AddFormValue) => {
    const Location = data.Location || "";
    const status = data.Status !== undefined ? data.Status : "";

    const formData = {
      Location: Location,
      Status: status,
    };
    console.log(formData);
    const response = await AdminUserService.addLocation(data);
    console.log(response);
    if (response.data.data != null) {
      // getLocation();
      alert("Location Added Successfully");
      closeAddLocationDialog();
      setisLodactionAdded(!isLodactionAdded);
    } else {
      alert(response.data.errors[0]);
    }
  };

  return (
    <>
      <form
        // key={2}
        // className="form-wrapper-space-around verticalScroll"
        style={{ width: "100%", height: "90%" }}
        onSubmit={handleSubmit(onSubmit)} //{handleSubmit(onSubmitEditPersonalInfo)}
        noValidate
      >
        <div
          className="form-wrapper-space-around verticalScroll"
          style={{ height: "85%" }}
        >
          <div className="horizontal-wrapper-spaceevenly">
            <div className="input-field-div-wrapper-large">
              <select
                className="dropdown-control-large-insidetextfield-new"
                id="FormLocation1"
                {...register("FormLocation1")}
                onChange={(e) => {
                  onChangeHandler(e, LocationCount + 1);
                }}
              >
                <option value={""}> Select Location </option>
                {LocationDesc?.map((item: any) => (
                  <option key={item.Id} value={item.Location}>
                    {item.Location}
                  </option>
                ))}
                ;
              </select>
              <label className="select-form-label" htmlFor="FormLocationId1">
                Location Name
              </label>
            </div>

            {/* <div className="input-field-div-wrapper-smaller">
              <CurrencyInput
                className="input-field-div-small"
                id="FormCost1"
                placeholder=""
                // defaultValue={0}
                {...register("FormCost1")}
                decimalsLimit={2}
                onChange={(e) => {
                  onChangeHandler(e, LocationCount + 1);
                }}
                // onValueChange={(value, name) => console.log(value, name)}
              />
              <label className="form-label" htmlFor="FormCost1">
                Cost
              </label>
            </div> */}
          </div>

          {/* line 2 */}
          <div className="horizontal-wrapper-spaceevenly">
            <div className="input-field-div-wrapper-large">
              <select
                className="dropdown-control-large-insidetextfield-new"
                id="FormLocation2"
                {...register("FormLocation2")}
                onChange={(e) => {
                  onChangeHandler(e, LocationCount + 2);
                }}
              >
                <option value={""}> Select Location </option>
                {LocationDesc?.map((item: any) => (
                  <option key={item.Id} value={item.Location}>
                    {item.Location}
                  </option>
                ))}
                ;
              </select>
              <label className="select-form-label" htmlFor="FormLocation2">
                Location Name
              </label>
            </div>

            {/* <div className="input-field-div-wrapper-smaller">
              <CurrencyInput
                className="input-field-div-small"
                id="FormCost2"
                placeholder=""
                // defaultValue={0}
                {...register("FormCost2")}
                decimalsLimit={2}
                onChange={(e) => {
                  onChangeHandler(e, LocationCount + 2);
                }}
                // onValueChange={(value, name) => console.log(value, name)}
              />
              <label className="form-label" htmlFor="FormCost2">
                Cost
              </label>
            </div> */}
          </div>

          {/* line 3 */}
          <div className="horizontal-wrapper-spaceevenly">
            <div className="input-field-div-wrapper-large">
              <select
                className="dropdown-control-large-insidetextfield-new"
                id="FormLocation3"
                {...register("FormLocation3")}
                onChange={(e) => {
                  onChangeHandler(e, LocationCount + 3);
                }}
              >
                <option value={""}> Select Location </option>
                {LocationDesc?.map((item: any) => (
                  <option key={item.Id} value={item.Location}>
                    {item.Location}
                  </option>
                ))}
                ;
              </select>
              <label className="select-form-label" htmlFor="FormLocation3">
                Location Name
              </label>
            </div>

            {/* <div className="input-field-div-wrapper-smaller">
              <CurrencyInput
                className="input-field-div-small"
                id="FormCost3"
                placeholder=""
                // defaultValue={0}
                {...register("FormCost3")}
                decimalsLimit={2}
                onChange={(e) => {
                  onChangeHandler(e, LocationCount + 3);
                }}
                // onValueChange={(value, name) => console.log(value, name)}
              />
              <label className="form-label" htmlFor="FormCost3">
                Cost
              </label>
            </div> */}
          </div>
        </div>
        <div
          className="horizontal-wrapper-centeralign"
          style={{ height: "15%" }}
        >
          <div className="submit-button-div ">
            <Button type="submit">Add</Button>
          </div>
        </div>
      </form>
      {/* Add Location */}
      <ReactModal
        isOpen={addLocationDialogOpen || false}
        className="addtype-modal"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "1rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            Add New Location
          </h1>
          <PageLink
            onClick={() => closeAddLocationDialog()}
            style={{ marginBottom: "1rem" }}
          >
            Cancel
          </PageLink>
        </div>
        <form onSubmit={Locationform.handleSubmit(addLocation)}>
          <div className="d-flex">
            <div className="input-field-div-wrapper w-100 me-4">
              <Label>Location</Label>
              <input
                className="input-field-div"
                placeholder="Location"
                {...Locationform.register("Location", {
                  required: "Location is required",
                })}
                name="Location"
                id="Location"
                autoComplete="off"
              />
              <p className="form-error form-error-position">
                {/* {errors.Location && errors.Location?.message} */}
              </p>
            </div>
            <div className="ms-4">
              <select
                style={{ marginTop: "6px" }}
                className="dropdown-control-large"
                {...Locationform.register("Status", { required: false })}
                name="Status"
                id="Status"
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
              {/* <p className="form-error form-error-position">
              {errors.Status?.message}
            </p> */}
            </div>
          </div>
          <div className="w-100 d-flex justify-content-center">
            <div className="submit-button-div">
              <Button type="submit">Add</Button>
            </div>
          </div>
        </form>
      </ReactModal>
    </>
  );
};

export default AddLocationInfo;
